import { Loader } from '@maersktankersdigital/web-components'
import { Box } from '@mui/material'

function LoadComponent() {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Loader />
    </Box>
  )
}

export default LoadComponent
